import { useState, useEffect } from 'react';

export default function useStickyState<T>(defaultValue: T, key: string): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    try {
      const stickyValue = window.localStorage.getItem(key);
      return stickyValue !== null ? (JSON.parse(stickyValue) as T) : defaultValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}": ${error}`);
      return defaultValue;
    }
  });
  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error writing localStorage key "${key}": ${error}`);
    }
  }, [key, value]);
  return [value, setValue];
}
